import React from "react";
import "./_styles.scss";
// import logo from "./img/CC_Horizontal_Logo-01.svg";

export default function AppLogo() {
  return (
    <div className="app-logo flex">
      <img
        src={require("./img/CCC_horizontol_logo.png")}
        alt="Odynn Logo"
        style={{
          width: "175px",
          margin: "10px"
        }}
      />
    </div>
  );
}
